<script>
  import { writable } from "svelte/store";
  import Modal, { bind } from "svelte-simple-modal";
  import Gallery from "./Gallery.svelte";
  import Statement from "./Statement.svelte";
  import { getSeries, getFilteredAlbums } from "./albums";

  const modal = writable(null);
  const openGallery = (album) => modal.set(bind(Gallery, { album }));
  const openOrdering = () => modal.set(Ordering);
  const openStatement = () => modal.set(Statement);

  let currentSeries = null;
  const setSeries = (s) => {
    currentSeries = s;
  };
  const resetSeries = () => {
    currentSeries = null;
  };

  let filteredAlbums;
  $: filteredAlbums = getFilteredAlbums(currentSeries);

  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  };

  const onLinkClick = (e) => e.stopPropagation();

  window.addEventListener("resize", appHeight);
  window.addEventListener("orientationchange", appHeight);
  appHeight();
</script>

<main>
  <div class="header">
    <button on:click={openStatement} class="header-button">Statement</button>
    <a href="mailto:jv@jasminevenes.com" class="header-link">Inquire</a>
    <a
      href="https://www.instagram.com/jv.folly/"
      target="_new"
      class="header-link">Instagram</a
    >
  </div>
  <div class="splash">
    <div class="title">Jasmine Venes</div>
    <div class="subtitle">Artist</div>
  </div>
  <div class="series">
    <div class="series-list">
      {#each getSeries() as s}
        <button on:click={() => setSeries(s)}>{s}</button>
      {/each}
    </div>
    {#if currentSeries}
      <div class="current-series">
        {currentSeries}
        <button on:click={resetSeries}>&#x2715;</button>
      </div>
    {/if}
  </div>
  <div class="current-work">
    <Modal
      show={$modal}
      styleWindow={{
        width: "100vw",
        height: "100vh",
        margin: 0,
        borderRadius: 0,
        background: "none",
      }}
      styleWindowWrap={{
        margin: 0,
        backdropFilter: "blur(50px)",
        "-webkit-backdrop-filter": "blur(20px) contrast(80%)",
      }}
      styleContent={{ height: "100%", padding: 0, maxHeight: "100%" }}
      styleCloseButton={{
        cursor: "pointer",
        borderRadius: 0,
        top: 0,
        right: 0,
        width: "55px",
        height: "55px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />
    <div class="carousel-wrapper">
      {#each filteredAlbums.years as year}
        <div class="year">{year}</div>
        <div class="carousel">
          {#each filteredAlbums.albumsByYear[year] as album (album.album)}
            <div
              on:click={() => openGallery(album.album)}
              class="album"
              class:sold={album.price === "sold"}
            >
              <img
                class="carousel-image"
                src="images/{album.album}/1_thumb.jpeg"
              />
              <p>
                <i>{album.name}</i>, {album.year}<br />
                {album.materials}, {album.size}
              </p>
            </div>
          {/each}
        </div>
      {/each}
    </div>
  </div>
</main>

<style>
  .header {
    background-color: black;
    padding: 1rem;
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
  .header .header-button,
  .header .header-link {
    cursor: pointer;
    background-color: black;
    border: none;
    padding: 2px 8px;
    color: #ddd;
    font-size: 0.9rem;
    font-family: "Nunito Sans";
    border-radius: 5px;
  }
  .splash {
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-transform: uppercase;
    padding: 3rem;
    gap: 1rem;
    color: #666;
  }
  .splash .title {
    text-transform: uppercase;
    font-size: 4rem;
  }
  .splash .subtitle {
    font-size: 1.5rem;
  }

  .current-work {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    padding: 2rem 2rem 20rem 2rem;
  }

  .current-work {
    background-color: black;
    color: #aaa;
  }

  .carousel {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 2rem;
  }

  .year {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    font-size: 2rem;
  }

  .album {
    display: flex;
    flex-direction: column;
    background-color: #222;
    cursor: pointer;
  }

  .album p {
    font-size: 12px;
    margin: 0;
    padding: 10px;
  }

  .album .price-container {
    display: flex;
    padding: 0px 10px 10px 10px;
    font-size: 12px;
  }

  .album .price-container a {
    color: #aaa;
    background-color: #333;
    border-radius: 4px;
    padding: 2px 8px;
  }

  .sold {
    position: relative;
  }

  .sold::before {
    content: "";
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    width: 10px;
    height: 10px;
    background-color: #ec644b;
    border-radius: 50%;
    z-index: 1;
  }
  .carousel-image {
    width: 300px;
  }

  a {
    color: #37c;
    text-decoration: none;
  }

  .hidden {
    display: none;
  }

  .series {
    background-color: #222;
    display: flex;
    flex-direction: column;
  }

  .series .series-list {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    justify-content: center;
    padding: 1rem;
  }

  .series .series-list button {
    font-family: "Nunito Sans";
    background-color: #222;
    border: none;
    color: #aaa;
    cursor: pointer;
    font-size: 0.9rem;
  }

  .series .current-series {
    padding: 2.5rem 1rem 1rem 1rem;
    background-color: black;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    color: #aaa;
  }

  .series .current-series button {
    background-color: black;
    border: none;
    color: #aaa;
    font-size: 1.2rem;
    font-family: "Nunito Sans";
    cursor: pointer;
  }

  @media (max-width: 800px) {
    .splash {
      padding: 1.5rem;
      gap: 0.5rem;
    }
    .splash .title {
      font-size: 2.5rem;
    }
    .splash .subtitle {
      font-size: 1rem;
    }
  }
</style>
